/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_subtitle = /** @type {(inputs: { orgName: NonNullable<unknown> }) => string} */ (i) => {
	return `Te han invitado a formar parte de ${i.orgName} a través de Bloque App.`
};

const en_invite_page_subtitle = /** @type {(inputs: { orgName: NonNullable<unknown> }) => string} */ (i) => {
	return `You've been invited to join ${i.orgName} through Bloque App.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ orgName: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_subtitle = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_subtitle", locale)
	if (locale === "es") return es_invite_page_subtitle(inputs)
	return en_invite_page_subtitle(inputs)
};
export { invite_page_subtitle as "invite.page.subtitle" }